// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__gcxKa","spin":"Spinner_spin__p0RVb"};